export const FORMA_PRAWNA_INNA_KOD = 'INNA'

export const FORMA_PRAWNA_OPTIONS = [
  { value: '00', label: 'stowarzyszenie niewpisane do KRS (kod 00)' },
  { value: '15', label: 'spółka partnerska (kod 15)' },
  { value: '16', label: 'spółka akcyjna (kod 16)' },
  {
    value: '17',
    label: 'spółka z ograniczoną odpowiedzialnością (kod 17)',
  },
  { value: '18', label: 'spółka jawna (kod 18)' },
  { value: '19', label: 'spółka cywilna (kod 19)' },
  { value: '20', label: 'spółka komandytowa (kod 20)' },
  { value: '21', label: 'spółka komandytowo-akcyjna (kod 21)' },
  { value: '22', label: 'spółka europejska (kod 22)' },
  { value: '24', label: 'przedsiębiorstwo państwowe (kod 24)' },
  { value: '26', label: 'towarzystwo ubezpieczeń wzajemnych (kod 26)' },
  { value: '34', label: 'towarzystwo reasekuracji wzajemnej (kod 34)' },
  {
    value: '39',
    label: 'spółdzielcza kasa oszczędnościowo-kredytowa (kod 39)',
  },
  { value: '40', label: 'spółdzielnia mieszkaniowa (kod 40)' },
  { value: '42', label: 'spółdzielnia europejska (kod 42)' },
  { value: '48', label: 'fundacja (kod 48)' },
  { value: '55', label: 'stowarzyszenie wpisane do KRS (kod 55)' },
  { value: '72', label: 'związek zawodowy (kod 72)' },
  { value: '73', label: 'organizacja pracodawców (kod 73)' },
  { value: '74', label: 'związek pracodawców (kod 74)' },
  { value: '76A', label: 'samorząd gospodarczy i zawodowy' },
  { value: '76B', label: 'koło gospodyń wiejskich' },
  { value: '79', label: 'oddział przedsiębiorcy zagranicznego (kod 79)' },
  { value: '80', label: 'przedstawicielstwo zagraniczne (kod 80)' },
  { value: '85', label: 'wspólnota mieszkaniowa (kod 85)' },
  { value: 'FI', label: 'fundusz inwestycyjny (kod FI)' },
  { value: 'FR', label: 'fundacja rodzinna (kod FR)' },
  {
    value: 'OG',
    label: 'osoba fizyczna prowadząca działalność gospodarczą (kod OG)',
  },
  { value: 'PA', label: 'prosta spółka akcyjna (kod PA)' },
  { value: FORMA_PRAWNA_INNA_KOD, label: 'Inna' },
]
